import { useMutation } from '@tanstack/react-query';
import https from 'utils/https';
import { ENDPOINTS } from 'utils/endpoints/endpoints';
import { useDispatch } from 'react-redux';
import { updateFeedbackData } from 'redux/slicers/feedbackSlice';

async function getFeedback() {
  const {
    data: { list }
  } = await https.get(ENDPOINTS.FEEDBACK);

  return list;
}

export const useGetFeedbackMutation = () => {
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: () => getFeedback(),
    onSuccess: data => {
      const updatedList = data.map(el => {
        return {
          first_name: el.userISbb_usersID_display.split(' ')[0],
          last_name: el.userISbb_usersID_display.split(' ')[1],
          email: '',
          feedback: el.msgISsmallplaintextbox,
          date: el._dateadded_display,
          id: el._id,
          user_id: el.userISbb_usersID,
          readYN: el.readYN
        };
      });

      dispatch(updateFeedbackData(updatedList));
    },
    onError: error => {
      console.log(error);
    }
  });
};
